import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

// importing the course screen styles for stylings
import "../styles/CoursesScreen.css";

// importing course cards components for showing courses
import QuizeCards from "./components/SubQuizeCards";

import { getQuizesByParentId } from "../../../../services/quiz/quize";

export default function SubQuizeIndexScreen() {
	const [subQuizes, setSubQuizes] = useState([]);
	const [parentQuiz, setParentQuiz] = useState(null);
	const [loading, setLoading] = useState(true);
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const parentQuizId = searchParams.get("parentQuizId");

	const fetchSubQuizes = async () => {
		try {
			setLoading(true);
			const response = await getQuizesByParentId(parentQuizId);
			if (response && response.length > 0) {
				setSubQuizes(response);
				// Set the first quiz as parent quiz info (assuming it contains parent info)
				setParentQuiz(response[0]);
			}
		} catch (error) {
			console.error("Error fetching sub-quizzes:", error);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		if (parentQuizId) {
			fetchSubQuizes();
		}
	}, [parentQuizId]);

	const handleQuizClick = (quiz) => {
		if (quiz.isSubQuiz) {
			// Navigate to sub-quiz listing page for this quiz
			navigate(`/home/sub-quize?parentQuizId=${quiz.id}`);
		} else {
			// Open quiz question popup
			navigate(`/home/quiz-page?quizeId=${quiz.id}`);
		}
	};

	if (loading) {
		return (
			<div className='HomeContextContainer'>
				<div>Loading sub-quizzes...</div>
			</div>
		);
	}

	return (
		<div className='HomeContextContainer'>
			<div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
				<button 
					onClick={() => navigate('/home/quize')}
					style={{
						background: 'none',
						border: 'none',
						fontSize: '16px',
						cursor: 'pointer',
						marginRight: '10px',
						color: '#007bff'
					}}
				>
					← Back to Quizzes
				</button>
			</div>
			<h2 className='CoursesScreenHeading'>
				{parentQuiz?.title ? `${parentQuiz.title} - Sub Quizzes` : 'Sub Quizzes'}
			</h2>
			<div className='CoursesScreenCoursesList'>
				{subQuizes && subQuizes.length > 0 ? (
					subQuizes?.map((quiz) => (
						<div key={quiz.id} onClick={() => handleQuizClick(quiz)}>
							<QuizeCards
								id={quiz.id}
								serialNumber={quiz.id}
								title={quiz.title}
								courseDescription={quiz.courseDescription}
								thumbnail={quiz.imgURL || "https://courses.learningmusicanywhere.com/images/a4e8afcd-2598-46c2-b372-759dd00c575f_introduction-to-Music-1A.jpg"}
								isSubQuiz={quiz.isSubQuiz}
							/>
						</div>
					))
				) : (
					<div>No sub-quizzes found.</div>
				)}
			</div>
		</div>
	);
} 